import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { formValueSelector } from 'redux-form/immutable';
import { createStructuredSelector } from 'reselect';
import AuthBottom from 'components/AuthBottom';
import AuthTop from 'components/AuthTop';
import SupportButton from 'components/SupportButton';
import RewardsCards from 'resources/RewardsCards-2.png';
import { FORM_NAME } from '../formConstants';
import './SuccessFormPage.css';

class SuccessFormPage extends Component {
  render() {
    const { formRenderer, email, hasCard } = this.props;
    const body = (
      <Fragment>
        <AuthTop hideLogo>
          <h2 className="sr-only focus-start" tabIndex="-1">
            Sign Up Complete
          </h2>
          <div className="form-page success-form-page">
            <div className="form-title">Thanks for joining!</div>
            <div className="description">
              Welcome! A verification email has been sent to you with
              instructions for activating your online account. Once you have
              activated your account, you will be able to sign into
              WindCreekCasino.com.
              <div className="email-info">{email || 'Unknown Email'}</div>
            </div>
            <div className="description">
              <span>Entered the wrong email address?</span>
              <span>
                Contact us on the support chat below and we&apos;ll get your
                account updated.
              </span>
            </div>
          </div>
        </AuthTop>
        <AuthBottom className="success-form-bottom">
          {!hasCard && (
            <div className="visit-message-container">
              <img className="rewards-card" src={RewardsCards} alt="" />
              <div className="message">
                The next time you travel to any Wind Creek casino, please visit
                Player Services to complete your rewards card sign up. Once
                completed, you will be able to redeem all of the prizes and
                rewards earned on WindCreekCasino.com
              </div>
            </div>
          )}
          <Link to="/" className={`btn button-color-blue btn-block`}>
            Okay, Thanks!
          </Link>
          <SupportButton />
        </AuthBottom>
      </Fragment>
    );

    const overrides = {
      submitText: '',
      onBack: undefined,
      backText: 'Okay, Thanks!',
      backClass: 'embedded-hidden'
    };
    const pageProps = Object.assign({}, this.props, overrides);
    return formRenderer(pageProps, body);
  }
}

const formSelector = formValueSelector(FORM_NAME);
const mapStateToProps = createStructuredSelector({
  email: state => formSelector(state, 'email')
});
const withConnect = connect(mapStateToProps);

const WrappedComponent = withConnect(SuccessFormPage);

WrappedComponent.FormFields = [];

export default WrappedComponent;
